'use client'

import { useEffect } from 'react'
import { useRouter } from 'next/navigation'
import { useAuth } from '@/hooks/useAuth'
import { isInTranslatorIframe } from '@/lib/i18n/inTranslatorIframe'
import { isEnterpriseDeployment } from '@/lib/deployment'
import { MartiniLoader } from '@/components/MartiniLoader'
import { signUpModalOwnsNavigation } from '@/components/auth'
import { HomePageContent } from './components/HomePageContent'

export function HomePageClient() {
  const router = useRouter()
  const { isAuthenticated, isAnonymous, isLoading } = useAuth()
  // `signUpModalOwnsNavigation()` keeps a signup completing in one of the
  // section CTAs from being redirected — and unmounted, see the loader below —
  // out from under itself; the modal routes a new account to /welcome.
  const shouldRedirect =
    !isLoading && isAuthenticated && !isAnonymous && !isInTranslatorIframe() && !signUpModalOwnsNavigation()

  useEffect(() => {
    // Logged-in users go to /projects
    if (!shouldRedirect) return
    router.replace('/projects')
  }, [router, shouldRedirect])

  // Enterprise signed-out visitors see EnterpriseLoginPage from SignedOutGate.
  // Once authenticated, keep the marketing homepage out of the paint while
  // the existing redirect sends them to their projects.
  if (isEnterpriseDeployment() || shouldRedirect) {
    return (
      <div className="flex min-h-svh items-center justify-center bg-background">
        <MartiniLoader className="text-foreground" />
      </div>
    )
  }

  return <HomePageContent />
}
